// extracted by mini-css-extract-plugin
export default {"card":"About_card__WJWgc","card-body":"About_card-body__WXHG0","heading":"About_heading__YugXf","imageContainer":"About_imageContainer__U+2KT"};